<template></template>
<script>
import { UrlSearch } from '../../../components/utils/UrlSearch'
import {getToken} from '../../../components/utils/auth'
import store from '@/store'
export default {
  mounted () {
    console.log(UrlSearch())
    //  ShopifyApp.init({
    //    apiKey: getToken(),
    //    shopOrigin: UrlSearch().shop
    //  });
    var url = window.location.href
    var arrUrl = url.split('?'); console.log(arrUrl[1])
    if (window.top == window.self) {
      var path = 'https://' + UrlSearch().shop + '/admin/apps/' + store.getters.shopTokenapps + '/home'

      var pa = path + arrUrl
      console.log(pa)
      window.location.assign(path)
    } else {
      ShopifyApp.redirect(url)
      console.log(url)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/install/install.vue